module.exports = __webpack_public_path__ + "media/images/checkout/challenger/call_confirmed_check-2a13121300bb4db3a9f841f7a25a5e39.svg";